import { Radio, Space } from 'antd';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { useEffect, useState } from 'react';

interface props {
    type: string;
    level1: string;
    level2: string;
}

const radioGroupStyle = {
    marginLeft: 6,
    paddingLeft: 35,
    borderLeft: '2px solid #1f8ddd',
}

const TAB3Component = ({ type, level1, level2 }: props) => {
    const [valueLevel1, setValueLevel1] = useState<string>();
    const [valueLevel2, setValueLevel2] = useState<string>();
    useEffect(() => {
        setValueLevel1(level1);
        setValueLevel2(level2);
    }, []);
    return (
        <div className="text-left ml-[146px]">
            {type == String(BUYER_CLASSIFICATION) ? (
                <Radio.Group value={valueLevel1}>
                    <Space direction="vertical" align="start">
                        <Radio name="level-1" value={'0-0'}>
                            選定
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00020020'} className="end-node">
                                    選定中
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-1'} className="level1">
                            入札
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00020040'}>入札中</Radio>
                                <Radio value={'00020050'}>申込前</Radio>
                                <Radio value={'00020060'} className="end-node">
                                    申込中
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-2'} className="level1">
                            契約
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00020080'}>売主契約中</Radio>
                                <Radio value={'00020090'}>契約準備中</Radio>
                                <Radio value={'00020100'}>契約締結中</Radio>
                                <Radio value={'00020110'} className="end-node">
                                    契約終了
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-3'} className="level1">
                            決済
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00020130'}>決済準備中</Radio>
                                <Radio value={'00020140'}>決済待ち</Radio>
                                <Radio value={'00020150'} className="end-node">
                                    決済実行中
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-4'} className="level1">
                            引継
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00020160'} className="end-node">
                                    引継手続中
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-5'} className="level1">
                            終了
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00020180'} className="end-node">
                                    取引完了
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Space>
                </Radio.Group>
            ) : (
                <Radio.Group value={valueLevel1}>
                    <Space direction="vertical" align="start">
                        <Radio name="level-1" value={'0-0'}>
                            査定
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00010020'}>査定準備</Radio>
                                <Radio value={'00010030'}>査定中</Radio>
                                <Radio value={'00010040'}>査定完了</Radio>
                                <Radio value={'00010045'} className="end-node">出品承認待ち</Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-1'} className="level1">
                            出品
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00010060'}>物件掲載中</Radio>
                                <Radio value={'00010070'} className="end-node">
                                    購入申込中
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-2'} className="level1">
                            契約
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00010090'}>契約準備</Radio>
                                <Radio value={'00010100'}>買主契約中</Radio>
                                <Radio value={'00010110'} className="end-node">
                                    契約終了
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-3'} className="level1">
                            決済
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00010130'}>決済準備中</Radio>
                                <Radio value={'00010140'}>決済待ち</Radio>
                                <Radio value={'00010150'} className="end-node">
                                    決済実行中
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-4'} className="level1">
                            引継
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00010170'} className="end-node">
                                    引継手続中
                                </Radio>
                            </Space>
                        </Radio.Group>
                        <Radio name="level-1" value={'0-5'} className="level1">
                            終了
                        </Radio>
                        <Radio.Group
                            style={radioGroupStyle}
                            value={valueLevel2}
                        >
                            <Space direction="vertical" align="start">
                                <Radio value={'00010190'} className="end-node">
                                    取引完了
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Space>
                </Radio.Group>
            )}
        </div>
    );
};
export default TAB3Component;
